import { useEffect, useState } from "react";
import { SurveyCreator, SurveyCreatorComponent } from "survey-creator-react";
import { surveyLocalization } from "survey-core";
import { StylesManager } from "survey-core";

// Import stylesheets for SurveyJS Library and Survey Creator
import "survey-core/defaultV2.css";
import "survey-creator-core/survey-creator-core.min.css";
import "./creator.css"
import { useLocation, useParams } from "react-router-dom";
import { useSupabaseData } from "../Hooks/useSupabaseData";

// Set translations for all supported locales
surveyLocalization.locales["lt"] = {
    ...surveyLocalization.locales["lt"],
    "otherItemText": "Kita (įrašykite)"
};

surveyLocalization.locales["et"] = {
    ...surveyLocalization.locales["et"],
    "otherItemText": "Muudel põhjustel (sisesta)"
};

surveyLocalization.locales["lv"] = {
    ...surveyLocalization.locales["lv"],
    "otherItemText": "Citiem iemesliem (ierakstiet)"
};

surveyLocalization.locales["ru"] = {
    ...surveyLocalization.locales["ru"],
    "otherItemText": "По другим причинам (укажите, пожалуйста)"
};

surveyLocalization.locales["en"] = {
    ...surveyLocalization.locales["en"],
    "otherItemText": "Other reasons (please specify)"
};

surveyLocalization.supportedLocales = ["lt", "en", "ru", "lv", "et" ];

StylesManager.applyTheme("defaultV2");

export function Creator() {
    const [creator, setCreator] = useState(new SurveyCreator({
        showLogicTab: true, haveCommercialLicense: true, showTranslationTab: true,
        clearInvisibleValues: 'none',
        localization: { currentLocale: 'lt' }
    }))
    const location = useLocation();
    const [single, setSingle] = useState([]);
    const { id } = useParams()
    const rawSourceTable = location.state?.ObjectInfo?.what || 'formos_tipai';
    const sourceTable = rawSourceTable === 'formos-tipai' ? 'formos_tipai' : rawSourceTable;
    const objectId = location.state?.id || id;
    const { getSingle: getObject, update: updateObject } = useSupabaseData({ name: sourceTable })
    const { data: formos, getAll: getFormos } = useSupabaseData({
        name: 'formos'
    })
    const { update: updateFormObject } = useSupabaseData({ name: 'formos' })
    useEffect(() => {
        if (!objectId) return;
        getObject(objectId, setSingle)
        getFormos()
    }, [getObject, getFormos, objectId])

    useEffect(() => {
        if (single?.attributes?.formObject) {
            let obj = creator
            obj.JSON = single.attributes.formObject;
            setCreator(obj)
        }
    }, [single, creator])

    creator.saveSurveyFunc = async (saveNo, callback) => {
        try {
            if (!single?.id) {
                throw new Error('Missing survey id');
            }

            const updatedTemplate = await updateObject(single.id, { formObject: creator.JSON }, setSingle);
            if (!updatedTemplate) {
                throw new Error('Failed to update template form_object');
            }

            const sameNameForms = (formos || []).filter(
                (e) => e.attributes.formosPavadinimas === single.attributes.formosPavadinimas
            );

            await Promise.all(
                sameNameForms.map((e) => updateFormObject(e.id, { formObject: creator.JSON }))
            );

            callback(saveNo, true);
        } catch (e) {
            console.error('Error updating form version in saveSurveyFunc:', e);
            callback(saveNo, false);
        }
        finally {
            if (objectId) {
                getObject(objectId, setSingle)
            }
        }
    };
    //     creator.toolbox.addItem(m)
    if (creator)
        creator.onSurveyInstanceCreated.add(function (sender, options) {
            //If we are creating a surface for designer surface

        });

    return (
        <div>
            <SurveyCreatorComponent creator={creator}></SurveyCreatorComponent>
        </div>
    );
}
